
import React from 'react';
import { useIsMobile } from '@/hooks/use-mobile';

const MissionSection = () => {
  const isMobile = useIsMobile();

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-16 items-center">
      <div className={isMobile ? "order-2" : ""}>
        <h2 className="text-2xl md:text-3xl font-serif font-semibold text-patrimoine-dark mb-6">Notre Mission</h2>
        <p className="text-patrimoine-muted mb-4">
          Fondée sur des principes d'excellence et de transparence, LA PATRIMONIALE s'engage à offrir des solutions financières personnalisées qui répondent aux objectifs patrimoniaux spécifiques de chaque client.
        </p>
        <p className="text-patrimoine-muted mb-4">
          Notre approche combine l'expertise financière, la connaissance approfondie des marchés et une vision à long terme pour assurer la croissance et la protection de votre patrimoine.
        </p>
        <p className="text-patrimoine-muted">
          Nous nous distinguons par notre capacité à proposer des stratégies innovantes dans divers domaines d'investissement, de l'assurance vie luxembourgeoise aux énergies vertes, en passant par les ETF et les métaux précieux.
        </p>
      </div>
      <div className={`overflow-hidden shadow-xl h-auto ${isMobile ? "order-1 mb-6" : ""}`}>
        <img 
          src="/lovable-uploads/e8cba85a-40dc-4681-9ff7-d69623d68ded.png" 
          alt="Bureaux de LA PATRIMONIALE" 
          className="w-full h-full object-cover"
        />
      </div>
    </div>
  );
};

export default MissionSection;
